import React from "react";
import {
  PATIENT_TYPE_STYLES,
  formatPatientTypeLabel,
  hasPatientTypeBadge,
} from "./appointmentViewShared";

type Props = {
  label?: string | null;
  /** Size / spacing classes; colours come from the label. */
  className?: string;
};

/**
 * Plan / New pill for the backend `patientTypeLabel`. Renders nothing for
 * "Existing Patient" (the default state) or an unknown label.
 */
export default function PatientTypeBadge({
  label,
  className = "inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold border shrink-0",
}: Props) {
  if (!hasPatientTypeBadge(label)) return null;
  return (
    <span className={`${className} ${PATIENT_TYPE_STYLES[label]}`}>
      {formatPatientTypeLabel(label)}
    </span>
  );
}
